/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ScholarshiptypeIdEnrollmentLinks202,
  PostApiV1ScholarshiptypeIdEnrollmentLinks400,
  PostApiV1ScholarshiptypeIdEnrollmentLinks401,
  PostApiV1ScholarshiptypeIdEnrollmentLinks404,
  PostApiV1ScholarshiptypeIdEnrollmentLinks500,
  PostApiV1ScholarshiptypeIdEnrollmentLinksMutationRequest,
  PostApiV1ScholarshiptypeIdEnrollmentLinksMutationResponse,
  PostApiV1ScholarshiptypeIdEnrollmentLinksPathParams,
} from "../../types/scholarshipTypeLinksDeMatrculaController/PostApiV1ScholarshiptypeIdEnrollmentLinks.ts";
import { saveScholarshipTypeEnrollmentLinksRequestViewModelSchema } from "../saveScholarshipTypeEnrollmentLinksRequestViewModelSchema.ts";
import { scholarshipTypeEnrollmentLinksViewModelSchema } from "../scholarshipTypeEnrollmentLinksViewModelSchema.ts";

export const postApiV1ScholarshiptypeIdEnrollmentLinksPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinksPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ScholarshiptypeIdEnrollmentLinks202Schema = z.lazy(
  () => scholarshipTypeEnrollmentLinksViewModelSchema,
) as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinks202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ScholarshiptypeIdEnrollmentLinks400Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinks400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ScholarshiptypeIdEnrollmentLinks401Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinks401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ScholarshiptypeIdEnrollmentLinks404Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinks404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ScholarshiptypeIdEnrollmentLinks500Schema =
  z.any() as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinks500>;

export const postApiV1ScholarshiptypeIdEnrollmentLinksMutationRequestSchema =
  z.lazy(
    () => saveScholarshipTypeEnrollmentLinksRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinksMutationRequest>;

export const postApiV1ScholarshiptypeIdEnrollmentLinksMutationResponseSchema =
  z.lazy(
    () => postApiV1ScholarshiptypeIdEnrollmentLinks202Schema,
  ) as unknown as ToZod<PostApiV1ScholarshiptypeIdEnrollmentLinksMutationResponse>;
